import { render, staticRenderFns } from "./ActivateCampaignPackageModal.vue?vue&type=template&id=130a8231"
import script from "./ActivateCampaignPackageModal.vue?vue&type=script&lang=js"
export * from "./ActivateCampaignPackageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports